// src/offerStatus.ts
import { BiSolidCheckCircle, BiSolidLogInCircle } from "react-icons/bi";
var OFFERED = {
  committed: false,
  tone: "info",
  Icon: BiSolidLogInCircle,
  label: "Offered to Driver"
};
var ACCEPTED = {
  committed: true,
  tone: "success",
  Icon: BiSolidCheckCircle,
  label: "Accepted by Driver"
};
var presentationForOfferStatus = (status) => status === "accepted" || status === "assigned" ? ACCEPTED : OFFERED;
var presentationForAssignmentState = (state) => state === "offered" ? OFFERED : ACCEPTED;
export {
  presentationForAssignmentState,
  presentationForOfferStatus
};
//# sourceMappingURL=offer-status.mjs.map